import React from "react";
import { SActionButton } from "@atlas/uicorn/lib/Display/LabelList";
import styled from "styled-components";

function ComposerHeaderField(props: {
  label: string;
  children: React.ReactElement;
}) {
  const { label, children } = props;
  return (
    <SComposerHeaderField>
      <SComposerHeaderFieldLabel>{label}</SComposerHeaderFieldLabel>
      {children}
    </SComposerHeaderField>
  );
}

export default ComposerHeaderField;

// #region Styles

const SComposerHeaderFieldLabel = styled.span`
  width: 3rem;
  flex-shrink: 0;
  color: ${(p) => p.theme.color.grey8};
  font-size: 1.3rem;

  &::after {
    content: ":";
  }
`;

const SComposerHeaderField = styled.div`
  display: flex;

  ${SActionButton} {
    background-color: transparent;
  }
`;

// #endregion
